import { takeEvery, all, put, call, retry, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import {
  meRequest,
  setMe,
  userLoginMetricsRequest,
  setAccountIsReadyStatus,
  setAccountIsReadyError,
  checkAccountIsReadyStatusRequest,
  retryWhileAccountIsNotReadyRequest,
  setMeStatus,
  setMeError
} from './usersSlice'

import { checkAccountIsReadyStatusInWorkspace, userLoginMetrics } from '../api/users'
import { AccountCreationProcess, User } from '../types'
import { ApiError, RequestStatus } from 'features/common'
import { queryClient } from 'queryClient'
import { usersMeQuery } from '../api/userQueries'

function* fetchMe() {
  try {
    yield put(setMeStatus(RequestStatus.Pending))
    const user: User = yield queryClient.fetchQuery(usersMeQuery)
    yield put(setMe(user))
    yield put(setMeStatus(RequestStatus.Fulfilled))
  } catch (e) {
    yield put(setMeStatus(RequestStatus.Rejected))
    yield put(setMeError(e as ApiError))
  }
}

function* registerUserLoginMetrics(action: PayloadAction<User>) {
  try {
    yield call(userLoginMetrics, action.payload)
  } catch (e) {
    // TODO
  }
}

function* checkAccountIsReadyStatus(action: PayloadAction<string>) {
  try {
    const status = yield call(checkAccountIsReadyStatusInWorkspace, action.payload)
    yield put(setAccountIsReadyStatus(status))
  } catch (e) {
    yield put(setAccountIsReadyError(e as ApiError))
  }
}

function* retryWhileAccountIsNotReady(action: PayloadAction<string>) {
  const ONE_SECOND = 1000
  const POLLING_INTERVAL = 2 * ONE_SECOND
  const POLLING_RETRIES = 99

  try {
    const accountIsReady = async (accountId) => {
      const status = await checkAccountIsReadyStatusInWorkspace(accountId)
      if (status !== AccountCreationProcess.Created) throw new Error('Account is not ready') // to keep retrying
    }
    yield retry(POLLING_RETRIES, POLLING_INTERVAL, accountIsReady, action.payload)
    yield put(setAccountIsReadyStatus(AccountCreationProcess.Created))
  } catch (e) {
    yield put(setAccountIsReadyError(e as ApiError))
  }
}

function* watchFetchUsers() {
  yield takeLatest(meRequest.type, fetchMe)
  yield takeEvery(userLoginMetricsRequest.type, registerUserLoginMetrics)
  yield takeEvery(checkAccountIsReadyStatusRequest.type, checkAccountIsReadyStatus)
  yield takeEvery(retryWhileAccountIsNotReadyRequest.type, retryWhileAccountIsNotReady)
}

export default function* usersSaga() {
  try {
    yield all([watchFetchUsers()])
  } catch (e) {
    // TODO
  }
}
